import { atom, useAtom } from 'jotai';
import { FlowItem } from 'api/type';

const isMaster = atom<boolean>(false);

export const dateTypeAtom = atom<'month' | 'HALF_MONTH'>('month');
export const countdownAtom = atom(0);

export const isMasterAtom = atom(
  (get) => get(isMaster),
  (get, set, b: boolean) => {
    set(isMaster, b);
  },
);

const guildId = atom<number>(0);

export const guildIdAtom = atom(
  (get) => get(guildId),
  (get, set, b: number) => {
    set(guildId, b);
  },
);

const uid = atom<number>(0);

export const uidAtom = atom(
  (get) => get(uid),
  (get, set, b: number) => {
    set(uid, b);
  },
);

const giftFlow = atom<FlowItem[]>();

export const giftConfigAtom = atom(
  (get) => get(giftFlow),
  (get, set, b: FlowItem[]) => {
    set(giftFlow, b);
  },
);

const coinFlow = atom<FlowItem[]>();

export const coinConfigAtom = atom(
  (get) => get(coinFlow),
  (get, set, b: FlowItem[]) => {
    set(coinFlow, b);
  },
);

const lang = atom<string>('');

export const langAtom = atom(
  (get) => get(lang),
  (get, set, b: string) => {
    set(lang, b);
  },
);

const salaryFlow = atom<FlowItem[]>();

export const salaryConfigAtom = atom(
  (get) => get(salaryFlow),
  (get, set, b: FlowItem[]) => {
    set(salaryFlow, b);
  },
);

type selectUserType = {
  uid: number;
  nickName: string;
  avatar: string;
  totalTime: number;
  day: number;
  date: string;
  danaId: number;
};

const selectUserData = atom<selectUserType>();

export const selectUserDataAtom = atom(
  (get) => get(selectUserData),
  (get, set, b: selectUserType) => {
    set(selectUserData, b);
  },
);

type masterInfoType = {
  uid: number;
  nickName: string;
  avatar: string;
  danaId: number;
  guildId: number;
  guildMembers: number;
};

const masterInfo = atom<masterInfoType>();

export const masterInfoAtom = atom(
  (get) => get(masterInfo),
  (get, set, b: masterInfoType) => {
    set(masterInfo, b);
  },
);
